import"react";import o from"../../../../_virtual/index3.js";var i={width:"1px",height:"0px",padding:0,overflow:"hidden",position:"fixed",top:"1px",left:"1px"};"production"===process.env.NODE_ENV||o.node;export{i as hiddenGuard};
//# sourceMappingURL=FocusGuard.js.map
